export interface GetFilteredImportTemplatesRequest extends PagingSortingBaseRequest {
  filterType: FilterType;
  companyIds?: number[];
  assetTypeId?: number;
  isDefault: boolean,
  isStandard: boolean,
  isActive?: boolean,
  sortBy: SortingImportTemplate;
}

export enum SortingImportTemplate {
  createdOn = 'createdOn',
  updatedOn = 'updatedOn'
}

export enum FilterType {
  all,
  company,
  assetType
}

export interface PagingSortingBaseRequest {
  quickSearch: string;
  asc: boolean;
  skip: number;
  take: number;
}
